import { Component, EventEmitter, Input, Output } from '@angular/core'
import { EluxIcon } from '@elxjs/ui'

@Component({
  selector: 'app-tag',
  standalone: true,
  imports: [EluxIcon],
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent {
  @Input() text: string = ''
  @Input() icon: string = ''
  @Input() iconSize: string = '20'
  @Output() onClick = new EventEmitter<void>()

  click() {
    this.onClick.emit()
  }
}
